export default {
  date: {
    localFormat: 'DD.MM.YYYY',
    localShortFormat: 'DD.MM',
    serverFormat: 'YYYY-MM-DDTkk:mmZ',
    serverSimpleFormat: 'YYYY-MM-DD',
    time: 'HH:mm:ss',
    shortTime: 'HH:mm',
    day: 'DD MMMM YYYY',
    message: 'HH:mm DD MMMM',
    dateTime: 'DD.MM.YYYY HH:mm',
    serverDateTime: 'YYYY-MM-DD HH:mm',
    serverDateTimeSeconds: 'YYYY-MM-DD HH:mm:ss'
  }
}
